import httpService from "./http.service";

class CustomersService {
  getCustomersUrl = "/users/";
  //   customersAC = "/customer/ac";

  getCustomers = () => {
    return httpService.get(this.getCustomersUrl);
  };
  getCustomer = (id) => {
    return httpService.get(this.getCustomersUrl + id);
  };
  createCustomer = (model) => {
    return httpService.post("/customers", model);
  };
  editCustomer = (id, model) => {
    return httpService.patch("/customers/" + id, model);
  };
  deleteCustomer = (id) => {
    return httpService.delete("/customers/" + id);
  };
}

const customersService = new CustomersService();
export default customersService;
